import { render, staticRenderFns } from "./Favorites.vue?vue&type=template&id=52b7acb3&scoped=true&"
import script from "./Favorites.vue?vue&type=script&lang=js&"
export * from "./Favorites.vue?vue&type=script&lang=js&"
import style0 from "./Favorites.vue?vue&type=style&index=0&id=52b7acb3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b7acb3",
  null
  
)

export default component.exports